// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_79fb830","italianLicense":"_4c2e64d"};